import React from 'react';
import './PasswordStrength.css';

function PasswordStrength({ password }) {
  if (!password) {
    return null;
  }

  const getPasswordStrength = (pwd) => {
    let strength = 0;
    const checks = {
      length: pwd.length >= 8,
      uppercase: /[A-Z]/.test(pwd),
      lowercase: /[a-z]/.test(pwd),
      number: /[0-9]/.test(pwd),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(pwd)
    };

    strength = Object.values(checks).filter(Boolean).length;

    if (strength <= 2) return { level: 'weak', percentage: 33, color: '#e74c3c' };
    if (strength <= 4) return { level: 'medium', percentage: 66, color: '#f39c12' };
    return { level: 'strong', percentage: 100, color: '#27ae60' };
  };

  const strength = getPasswordStrength(password);
  const checks = {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password)
  };

  const getStrengthLabel = () => {
    if (strength.level === 'weak') return 'Weak';
    if (strength.level === 'medium') return 'Medium';
    return 'Strong';
  };

  return (
    <div className="password-strength">
      <div className="password-strength-bar">
        <div
          className="password-strength-fill"
          style={{
            width: `${strength.percentage}%`,
            backgroundColor: strength.color
          }}
        />
      </div>
      <div className="password-strength-label">
        <span style={{ color: strength.color }}>{getStrengthLabel()}</span>
      </div>
      <div className="password-requirements">
        <div className={checks.length ? 'requirement-met' : 'requirement-unmet'}>
          {checks.length ? '✓' : '✗'} At least 8 characters
        </div>
        <div className={checks.uppercase ? 'requirement-met' : 'requirement-unmet'}>
          {checks.uppercase ? '✓' : '✗'} One uppercase letter
        </div>
        <div className={checks.lowercase ? 'requirement-met' : 'requirement-unmet'}>
          {checks.lowercase ? '✓' : '✗'} One lowercase letter
        </div>
        <div className={checks.number ? 'requirement-met' : 'requirement-unmet'}>
          {checks.number ? '✓' : '✗'} One number
        </div>
        <div className={checks.special ? 'requirement-met' : 'requirement-unmet'}>
          {checks.special ? '✓' : '✗'} One special character
        </div>
      </div>
    </div>
  );
}

export default PasswordStrength;

